import { render } from "./BlKanban.vue?vue&type=template&id=c148fb60&scoped=true"
import script from "./BlKanban.vue?vue&type=script&lang=js"
export * from "./BlKanban.vue?vue&type=script&lang=js"

import "./BlKanban.vue?vue&type=style&index=0&id=c148fb60&scoped=true&lang=scss"

import exportComponent from "/tmp/5e119732-5ebd-42f7-baa8-4916aa59fc29/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c148fb60"]])

export default __exports__